import { getCurrentUserTypeRoles } from './userHelpers';
import { SCHEDULE_SERVICES_LISTING_TYPE } from './scheduleServiceSlots';

const PROFESSIONAL_DIRECTORY_LISTING_TYPE = 'professional-directory';

export const getAllowedListingTypesForUser = (config, currentUser) => {
  if (!currentUser?.id) return [];

  const { customer, provider } = getCurrentUserTypeRoles(config, currentUser);
  const listingTypes = config?.listing?.listingTypes || [];

  if (provider && !customer) {
    return listingTypes.filter(type =>
      [SCHEDULE_SERVICES_LISTING_TYPE, PROFESSIONAL_DIRECTORY_LISTING_TYPE].includes(
        type.listingType
      )
    );
  }

  if (customer && !provider) {
    return listingTypes.filter(
      type =>
        ![SCHEDULE_SERVICES_LISTING_TYPE, PROFESSIONAL_DIRECTORY_LISTING_TYPE].includes(
          type.listingType
        )
    );
  }

  return [];
};

export const canCreateListingType = (config, currentUser, listingType) =>
  getAllowedListingTypesForUser(config, currentUser).some(
    type => type.listingType === listingType
  );
